// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("footer/webgl-logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-header {
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    height: 60px;
    width: 100%;
    line-height: 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    background: linear-gradient(to top, #cecece, #ffffff);
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .25);
}

.app-header-title {
    font-weight: bold;
    position: relative;
    top: 16px;
    margin: 0 35px;
    font-family: sans-serif;
    font-size: large;
    padding: 0;
}

.home-button {
    position: relative;
    left: 12px;
    top: 6px;
    background: rgba(60, 60, 60, 0);
    margin: 0;
    padding: 0;
    color: #ffffff;
    height: 48px;
    width: 48px;
    border-radius: 4px;
}

.home-button:hover {
    background: #9b9b9b;
}

.home-button img {
    position: relative;
    top: 3px;
    width: 48px;
    height: 48px;
}

.app-container {
    position: relative;
    top: 0;
    padding-top: 60px;
}

.toolbar-container {
    position: relative;
    height: 40px;
    z-index: 90;
    background: linear-gradient(to left, #d2d2d2, #e7e7e7);
    display: flex;
    border-bottom: 1px solid #d9d7d7;
    border-top: 0;
    box-sizing: border-box;
}

.toolbar-left-button {
    background: rgba(255, 255, 255, 0);
    color: #000000;
    margin: 0;
    border-radius: 0;
    width: 140px;
}

.toolbox-right-button {
    background: rgba(255, 255, 255, 0);
    padding-left: 20px;
    padding-right: 20px;
    color: #000000;
    margin: 0;
    border-radius: 0;
    height: 39px;
    width: 200px;
}

.toolbar-container button:hover {
    background: rgba(197, 197, 197, 0.54);
}

.bottom-toolbox-container {
    position: relative;
    height: 65px;
    z-index: 100;
    background: linear-gradient(to right, #3c3c3c, #1a1a1a);
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #d9d7d7;
    box-sizing: border-box;
}

.bottom-toolbox-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    margin: 0 10px 0 10px;
    padding: 0 0 0 0;
    background: rgba(60, 60, 60, 0);
    border: 1px solid rgba(60, 60, 60, 0);
    color: #ffffff;
    height: 55px;
    width: 70px;
    text-align: center;
    font-size: x-small;
    border-radius: 10px;
}

.bottom-toolbox-button-selected {
    background: rgba(60, 60, 60, 0);
    border-color: #8d8d8d;
}

.bottom-toolbox-button img {
    width: 32px;
    height: 32px;
    margin-bottom: 5px;
    margin-top: 5px;
    border-radius: 7px;
}

.bottom-toolbox-button:hover {
    background: #1f1f1f;
    border-color: #d9d7d7;
}

.bottom-toolbox-button-selected:hover {
    background: #1f1f1f;
    border-color: #d9d7d7;
}

.bottom-toolbox-button div {
    position: absolute;
    margin-top: -141px;
    padding-bottom: 50px;
}

.grid-button {
    background: #3C3C3C;
    color: #ffffff;
    margin: 0;
    height: 45px;
    width: 45px;
    border-radius: 0;
    border: 1px solid #2d2d2d;
    display: flex;
    justify-content: center;
    align-items: center;
}

.grid-button:hover {
    background: #1f1f1f;
    border: 1px solid #565555;
}

.grid-button-selected {
    background: #1f1f1f;
}

.main-container {
    display: flex;
    flex-direction: row;
    height: calc(100dvh - 203px);
    width: 100dvw;
    position: relative;
}

.setting-container {
    margin-left: 5px;
    z-index: 10;
    width: 260px;
}

.webgl-container {
    z-index: 0;
    position: fixed;
    width: 100dvw;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.iframe-container {
    overflow: hidden;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 2px;
    margin-right: 5px;
}

.iframe-container iframe {
    width: 100dvw;
    height: calc(100dvh - 125px);;
    border: none;
    position: relative;
}

#unity-footer {
    position: relative;
}

#unity-webgl-logo {
    float: left;
    width: 204px;
    height: 38px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
}

.structure-list-container {
    margin-top: 10px;
    margin-left: 5px;
    z-index: 10;
    padding: 0;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, .6);
    flex-direction: column;
    width: 260px;
    height: calc(100dvh - 230px);
    overflow-y: auto;
    overflow-x: hidden;
    background: linear-gradient(to top, #e1e1e1, #eaeaea);
    flex-shrink: 0;
}

.list-container {
    z-index: 10;
    padding: 0;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, .6);
    flex-direction: column;
    width: 260px;
    height: calc(100dvh - 230px);
    margin-top: 10px;
    margin-right: 10px;
    overflow-y: auto;
    overflow-x: hidden;
    background: linear-gradient(to top, #e1e1e1, #eaeaea);
    flex-shrink: 0;
    margin-left: auto;
}

.list-container button {
    width: 300px;
    height: 50px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    margin: 5px;
    cursor: pointer;
}


.navigation-buttons-container {
    display: flex;
    align-items: center;
    justify-items: center;
    padding: 10px 10px;
    flex-direction: row;
}

.navigation-buttons-container button {
    width: 300px;
    height: 50px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    margin: 5px;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/ViewerApp.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,qDAAqD;IACrD,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,+BAA+B;IAC/B,SAAS;IACT,UAAU;IACV,cAAc;IACd,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,sDAAsD;IACtD,aAAa;IACb,gCAAgC;IAChC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,uDAAuD;IACvD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,+BAA+B;IAC/B,qCAAqC;IACrC,cAAc;IACd,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,SAAS;IACT,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,aAAa;IACb,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,oEAAuD;AAC3D;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,sBAAsB;IACtB,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,qDAAqD;IACrD,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,sBAAsB;IACtB,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,qDAAqD;IACrD,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB","sourcesContent":[".app-header {\n    position: fixed;\n    z-index: 100;\n    top: 0;\n    left: 0;\n    height: 60px;\n    width: 100%;\n    line-height: 30px;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: row;\n    background: linear-gradient(to top, #cecece, #ffffff);\n    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .25);\n}\n\n.app-header-title {\n    font-weight: bold;\n    position: relative;\n    top: 16px;\n    margin: 0 35px;\n    font-family: sans-serif;\n    font-size: large;\n    padding: 0;\n}\n\n.home-button {\n    position: relative;\n    left: 12px;\n    top: 6px;\n    background: rgba(60, 60, 60, 0);\n    margin: 0;\n    padding: 0;\n    color: #ffffff;\n    height: 48px;\n    width: 48px;\n    border-radius: 4px;\n}\n\n.home-button:hover {\n    background: #9b9b9b;\n}\n\n.home-button img {\n    position: relative;\n    top: 3px;\n    width: 48px;\n    height: 48px;\n}\n\n.app-container {\n    position: relative;\n    top: 0;\n    padding-top: 60px;\n}\n\n.toolbar-container {\n    position: relative;\n    height: 40px;\n    z-index: 90;\n    background: linear-gradient(to left, #d2d2d2, #e7e7e7);\n    display: flex;\n    border-bottom: 1px solid #d9d7d7;\n    border-top: 0;\n    box-sizing: border-box;\n}\n\n.toolbar-left-button {\n    background: rgba(255, 255, 255, 0);\n    color: #000000;\n    margin: 0;\n    border-radius: 0;\n    width: 140px;\n}\n\n.toolbox-right-button {\n    background: rgba(255, 255, 255, 0);\n    padding-left: 20px;\n    padding-right: 20px;\n    color: #000000;\n    margin: 0;\n    border-radius: 0;\n    height: 39px;\n    width: 200px;\n}\n\n.toolbar-container button:hover {\n    background: rgba(197, 197, 197, 0.54);\n}\n\n.bottom-toolbox-container {\n    position: relative;\n    height: 65px;\n    z-index: 100;\n    background: linear-gradient(to right, #3c3c3c, #1a1a1a);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-top: 1px solid #d9d7d7;\n    box-sizing: border-box;\n}\n\n.bottom-toolbox-button {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n    margin: 0 10px 0 10px;\n    padding: 0 0 0 0;\n    background: rgba(60, 60, 60, 0);\n    border: 1px solid rgba(60, 60, 60, 0);\n    color: #ffffff;\n    height: 55px;\n    width: 70px;\n    text-align: center;\n    font-size: x-small;\n    border-radius: 10px;\n}\n\n.bottom-toolbox-button-selected {\n    background: rgba(60, 60, 60, 0);\n    border-color: #8d8d8d;\n}\n\n.bottom-toolbox-button img {\n    width: 32px;\n    height: 32px;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    border-radius: 7px;\n}\n\n.bottom-toolbox-button:hover {\n    background: #1f1f1f;\n    border-color: #d9d7d7;\n}\n\n.bottom-toolbox-button-selected:hover {\n    background: #1f1f1f;\n    border-color: #d9d7d7;\n}\n\n.bottom-toolbox-button div {\n    position: absolute;\n    margin-top: -141px;\n    padding-bottom: 50px;\n}\n\n.grid-button {\n    background: #3C3C3C;\n    color: #ffffff;\n    margin: 0;\n    height: 45px;\n    width: 45px;\n    border-radius: 0;\n    border: 1px solid #2d2d2d;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.grid-button:hover {\n    background: #1f1f1f;\n    border: 1px solid #565555;\n}\n\n.grid-button-selected {\n    background: #1f1f1f;\n}\n\n.main-container {\n    display: flex;\n    flex-direction: row;\n    height: calc(100dvh - 203px);\n    width: 100dvw;\n    position: relative;\n}\n\n.setting-container {\n    margin-left: 5px;\n    z-index: 10;\n    width: 260px;\n}\n\n.webgl-container {\n    z-index: 0;\n    position: fixed;\n    width: 100dvw;\n    height: 100dvh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.iframe-container {\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    margin-top: 2px;\n    margin-right: 5px;\n}\n\n.iframe-container iframe {\n    width: 100dvw;\n    height: calc(100dvh - 125px);;\n    border: none;\n    position: relative;\n}\n\n#unity-footer {\n    position: relative;\n}\n\n#unity-webgl-logo {\n    float: left;\n    width: 204px;\n    height: 38px;\n    background: url(footer/webgl-logo.png) no-repeat center;\n}\n\n.structure-list-container {\n    margin-top: 10px;\n    margin-left: 5px;\n    z-index: 10;\n    padding: 0;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, .6);\n    flex-direction: column;\n    width: 260px;\n    height: calc(100dvh - 230px);\n    overflow-y: auto;\n    overflow-x: hidden;\n    background: linear-gradient(to top, #e1e1e1, #eaeaea);\n    flex-shrink: 0;\n}\n\n.list-container {\n    z-index: 10;\n    padding: 0;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, .6);\n    flex-direction: column;\n    width: 260px;\n    height: calc(100dvh - 230px);\n    margin-top: 10px;\n    margin-right: 10px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    background: linear-gradient(to top, #e1e1e1, #eaeaea);\n    flex-shrink: 0;\n    margin-left: auto;\n}\n\n.list-container button {\n    width: 300px;\n    height: 50px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    margin: 5px;\n    cursor: pointer;\n}\n\n\n.navigation-buttons-container {\n    display: flex;\n    align-items: center;\n    justify-items: center;\n    padding: 10px 10px;\n    flex-direction: row;\n}\n\n.navigation-buttons-container button {\n    width: 300px;\n    height: 50px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    margin: 5px;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
